import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=fa94b2f0&scoped=true&"
import script from "./PasswordReset.vue?vue&type=script&lang=tsx&"
export * from "./PasswordReset.vue?vue&type=script&lang=tsx&"
import style0 from "./PasswordReset.vue?vue&type=style&index=0&id=fa94b2f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa94b2f0",
  null
  
)

export default component.exports